import { render } from "./SenderInformationDialog.vue?vue&type=template&id=59d79f1b"
import script from "./SenderInformationDialog.vue?vue&type=script&lang=js"
export * from "./SenderInformationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__